import * as Joi from 'joi';
import { CandidateDetailsFormData } from '../../../models';
import {
  getJoiObject,
  getMasterCodeObjectDropdownSchema,
  validateNRIC,
} from '../../../utils/JoiUtils';

const candidateDetailsSchema = (disableValidateSinBirthCertNo: boolean = false) =>
  Joi.object<CandidateDetailsFormData>({
    name: Joi.string().max(66).required().messages({
      'string.empty': 'Name is not allowed to be empty',
      'string.max': 'Name is too long',
      'any.required': 'Name is required',
    }),

    singaporeBirthCertNo: getJoiObject(
      Joi.string()
        .alphanum()
        .required()
        .max(20)
        .custom(validateNRIC, 'Singapore Birth Cert No')
        .messages({
          'any.required': 'Singapore Birth Cert No is required',
          'string.empty': `Singapore Birth Cert No is not allowed to be empty`,
          'string.alphanum': `Singapore Birth Cert No should be alphanumeric`,
          'string.max': 'Singapore Birth Cert No is too long',
          'string.pattern.nric': 'Invalid Singapore Birth Cert No',
          'string.pattern.fin': 'Invalid Singapore Birth Cert No',
          'string.pattern.startCharError':
            'Invalid Singapore Birth Cert No i.e. must start with S, T, F, G or M',
        }),
      disableValidateSinBirthCertNo
    ),
    dateOfAttainedSPRStatus: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Date Attained SPR is not allowed to be empty',
        'string.base': 'Date Attained SPR is not allowed to be empty',
        'string.empty': 'Date Attained SPR is not allowed to be empty',
      }),
      !disableValidateSinBirthCertNo
    ),
    uinFinPassport: Joi.string().alphanum().required().max(20).messages({
      'string.empty': 'NRIC/FIN/Passport No. is not allowed to be empty',
      'string.max': 'NRIC/FIN/Passport No. is too long',
      'any.required': 'NRIC/FIN/Passport No. is required',
    }),
    motherTongueLanguageToBeTaken: getMasterCodeObjectDropdownSchema(
      false,
      'Mother Tongue Language to be taken'
    ),
  });

export default candidateDetailsSchema;
